module.exports = __webpack_public_path__ + "img/invoice.8a600d06.svg";